export const index = {
  "ChineseSite" : "English Site",
  "LogIn" : "Log In",

  "LeadingEnterprise" : "Leading Enterprise in Comprehensive Solutions for Smart Factories",
  "MakingWorld" : "Making World-Class Companies Our Clients Making Our Clients World-Class Companies",
  "CleverMax" : "Clever Max",
  "TheMostEfficient" : "The Most Efficient Smart Hanging Production Line",
  "TurningFirst" : "Turning First-class Customers into Our Clients, and Our Clients into First-class Businesses",
  "ContactUsNow" : "Contact Us Now",
  "AnInterconnected" : "An Interconnected Intelligent World",
  "CleverMaxBrandStory" : "CleverMax Brand Story",
  "Expertsin" : "Experts in Comprehensive Smart Factory Solutions",
  "ExploreIndustrySolutions" : "Explore Industry Solutions",
  "free" : "Consultation",
  "BusinessPartnerships" : '',//"Business Partnerships",
  "YearsofCollaboration" : "Years of Collaboration",

  "IndustryPainPoints" : "Industry Pain Points",
  "IndustryFeatures" : "Industry Features",
  "RequestaDemo" : "Request a Demo",
  "Terms" : "Terms",
  "VoiceofCustomer" : "Voice of Customer",
  "CustomerCases" : "Customer Cases",
  "ProductsApplied" : "Products Applied",
  "Location" : "Location",
  "hot" : "Trending Topic",
  "keyword" : "Please enter the keywords to search",
  "Engineering" : "Engineering Collaboration",




}



// WEBPACK FOOTER //
// ./src/lang/en.js